<template>
    <b-container fluid>
        <b-row class="my-4">
            <b-col md="6">
                <div v-if="date_from" class="py-2 print-show">Datum od: {{date_from | moment("DD.MM.YYYY.")}}</div>
                <b-form-group :label-cols-md="4"
                              label="Datum od:"
                              label-for="date_from">
                    <date-picker format="DD.MM.YYYY."
                                 v-model="date_from"
                                 :lang="$parent.hrv"
                                 :first-day-of-week="1"
                                 class="w-100"
                                 id="date_from">
                    </date-picker>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <div v-if="date_to" class="py-2 print-show">Datum do: {{date_to | moment("DD.MM.YYYY.")}}</div>
                <b-form-group :label-cols-md="4"
                              label="Datum do:"
                              label-for="date_to">
                    <date-picker format="DD.MM.YYYY."
                                 v-model="date_to"
                                 :lang="$parent.hrv"
                                 :first-day-of-week="1"
                                 class="w-100"
                                 id="date_to">
                    </date-picker>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row class="flex-center my-2">
            <b-col>
                <table class="table b-table table-striped table-hover table-bordered text-center align-middle">
                    <thead>
                    <tr>
                        <th>
                            <h3>Knjiga ulaznih faktura - KUF</h3>
                        </th>
                    </tr>
                    </thead>
                </table>
            </b-col>
        </b-row>

        <b-row>
            <b-col v-if="kufRows">
                <roza-table :items="kufRows"
                            :fields="kufFields"
                            :prenosFields="prenosFields"
                            :prenosColspan="6"
                            :per-page="perPage"
                            :current-page="currentPage"
                            :actions="actions"
                            @action="action"
                            print-page
                            actionHide="appended"
                            class="table-sm">
                    <template slot="custom-header">
                        <tr>
                            <th colspan="2"></th>
                            <th colspan="2">RAČUN</th>
                            <th colspan="7">DOBAVLJAČ - ISPORUČITELJ dobra ili usluge</th>
                            <th></th>
                            <th colspan="3">ULAZNI POREZ</th>
                        </tr>
                        <tr>
                            <th colspan="7"></th>
                            <th colspan="2">RAČUN</th>
                            <th colspan="2">PLAĆANJE</th>
                            <th colspan="4"></th>
                        </tr>
                    </template>
                    <template slot="custom-header2">
                        <tr>
                            <th>1</th>
                            <th>a</th>
                            <th>2</th>
                            <th>3</th>
                            <th>b</th>
                            <th>4</th>
                            <th>5</th>
                            <th>6</th>
                            <th>7</th>
                            <th>8</th>
                            <th>9</th>
                            <th>10</th>
                            <th>11</th>
                            <th>12</th>
                            <th>13</th>
                        </tr>
                    </template>
                    <template slot="id_number" slot-scope="data">
                        <template v-if="data.item.associate_pdv_number">
                            {{data.item.associate_pdv_number}}
                        </template>
                        <template v-else>
                            {{data.item.associate_id_number}}
                        </template>
                    </template>
                    <template slot="datumi" slot-scope="data">
                        <template v-for="i in data.item.entry_order_rows">
                            <template v-if="[12,15,13].includes(i.konto_id) && i.type === 1">
                                {{i.invoice_date | moment("DD.MM.YYYY.")}}<br/>
                            </template>
                        </template>
                    </template>
                    <template slot="iznos" slot-scope="data">
                        <template v-for="i in data.item.entry_order_rows">
                            <template v-if="[12,15,13].includes(i.konto_id) && i.type === 1">
                                {{i.debit}}<br/>
                            </template>
                        </template>
                    </template>
                </roza-table>

                <b-pagination @input="getRows"
                              align="right"
                              v-if="kufRows"
                              :total-rows="kufRows.total"
                              v-model="currentPage"
                              :per-page="perPage">
                </b-pagination>
            </b-col>
        </b-row>
        <b-btn @click="getCsvRows" variant="outline-success" class="float-right">Dohvati CSV</b-btn>

        <set-index-modal
                ref="setIndex"
                index="kuf_index"
                :item="selectedRow">
        </set-index-modal>
    </b-container>
</template>

<script>
    export default {
        name: 'Kuf',
        data() {
            return {
                kufRows: null,
                date_from: null,
                date_to: null,
                variant: null,
                kufFields: [
                    {
                        key: 'kuf_index',
                        label: 'Broj'
                    },
                    {
                        key: 'document_date',
                        label: 'Datum KUF-a.',
                        date: true
                    },
                    {
                        key: 'number',
                        label: 'Broj računa',
                    },
                    {
                        key: 'invoice_date',
                        label: 'Datum',
                        date: true
                    },
                    {
                        key: 'associate_code',
                        label: 'Šifra sur.'
                    },
                    {
                        key: 'associate_name',
                        label: 'NAZIV - ime i prezime i sjedište/prebivalište'
                    },
                    {
                        key: 'id_number',
                        label: 'IDB / JMBG'
                    },
                    {
                        key: 'ravnoteza',
                        label: 'IZNOS RAČUNA BEZ POREZA',
                        class: 'text-right'
                    },
                    {
                        key: 'total_credit',
                        label: 'UKUPNI IZNOS RAČUNA S POREZOM',
                        class: 'text-right'
                    },
                    {
                        key: 'datumi',
                        label: 'DATUM'
                    },
                    {
                        key: 'iznos',
                        label: 'IZNOS PLAĆANJA',
                        class: 'text-right'
                    },
                    {
                        key: '',
                        label: 'PAUŠALNA NAKNADA'
                    },
                    {
                        key: 'total_tax_debit',
                        label: 'UKUPNO'
                    },
                    {
                        key: 'tax_debit_can',
                        label: 'MOŽE SE ODBIT',
                        class: 'text-right'
                    },
                    {
                        key: 'tax_debit_cant',
                        label: 'NE MOŽE SE ODBIT',
                        class: 'text-right'
                    }
                ],
                prenosFields: [
                    '',
                    'totalRavnoteza',
                    'totalCredit',
                    '',
                    'totalPaid',
                    '',
                    'totalTaxDebit',
                    'totalTaxDebitCan',
                    'totalTaxDebitCant'
                ],
                actions: {
                    index: {
                        name: 'Dodijeli redni br.',
                        icon: 'fa fa-hashtag'
                    }
                },
                currentPage: 1,
                perPage: 10,
                selectedRow: null
            }
        },
        computed: {
            selectedClient: function () {
                return this.$store.getters.selectedClient;
            }
        },
        methods: {
            getRows() {
                axiOsta.get(api.clients + this.selectedClient.id + api.taxRows + 1, {
                    params: {
                        page: this.currentPage,
                        perPage: this.perPage,
                        from: this.date_from,
                        to: this.date_to,
                        variant: this.variant,
                        year: this.$cookie.get('ezint-year')
                    }
                }).then(response => {
                    if (response.status === 200) {
                        this.kufRows = response.data;
                    }
                })
            },
            action: function (action, item) {
                switch (action) {
                    case 'index':
                        this.selectedRow = item;
                        this.$refs.setIndex.show();
                        break;
                }
            },
            getCsvRows() {
                axiOsta.post(api.clients + this.selectedClient.id + api.taxRows + 1, {
                    params: {
                        page: this.currentPage,
                        perPage: this.perPage,
                        from: this.date_from,
                        to: this.date_to,
                        variant: this.variant,
                        year: this.$cookie.get('ezint-year')
                    }
                }, {responseType: 'blob'}).then(response => {
                    if (response.status === 200) {
                        const blob = new Blob([response.data], {type: response.data.type});
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        console.log(response.headers['content-disposition']);
                        const contentDisposition = response.headers['content-disposition'];
                        let fileName = 'unknown';
                        if (contentDisposition) {
                            const fileNameMatch = contentDisposition.match(/(?<=filename=).*/);
                            fileName = fileNameMatch[0];
                        }
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url);
                    }
                })
            },
        },
        created() {
            this.variant = this.$route.params.variant === 'a' ? 0 : 1;
            if (this.selectedClient != null) {
                this.getRows();
            }
            eventBus.$on('year-changed', () => {
                this.getRows();
            });
        },
        mounted() {
            this.$on('get-rows', () => this.getRows())
        },
        watch: {
            selectedClient: function (newValue, oldValue) {
                if (oldValue == null) {
                    this.getRows();
                }
            },
            date_from: function () {
                this.getRows();
            },
            date_to: function () {
                this.getRows();
            },
            '$route': function (to, from) {
                if (to.params.variant === 'a') {
                    this.variant = 0;
                } else {
                    this.variant = 1;
                }
                if (this.selectedClient != null) {
                    this.getRows();
                }
            }
        }
    }
</script>
